import styled from 'styled-components';

import * as colors from '../../shared/colors';

export const SectionHeading = styled.h2`
    font-size: 1.2rem;
`;

export const AccordionContainer = styled.div`
    border: 1px solid ${colors.primaryColor};
    border-radius: 5px;
    margin-bottom: 1px;
    padding: 3px 3px;
    @media (min-width: 650px) {
        padding: 5px 30px;
    }
`;

interface IAccordionHeader {
    $pointer: boolean;
}

export const AccordionHeader = styled.div<IAccordionHeader>`
    cursor: ${({ $pointer }) => $pointer ? 'pointer' : 'auto'};
    display: flex;
    align-items: center;
    > * {
        margin: 0 3px;
    }
    margin: 0 -3px;
    padding: 4px 0;
    @media (min-width: 400px) {
        > * {
            margin: 0 5px;
        }
        margin: 0 -5px;

    }
    @media (min-width: 650px) {
        > * {
            margin: 0 10px;
        }
        margin: 0 -10px;

    }
    svg {
        flex-shrink: 0;
    }
`;

export const AccordionHeading = styled.h3`
    flex-grow: 1;
    font-size: 1.1rem;
`;

export const AccordionBody = styled.div`
    margin-top: 1rem;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: column;
    > * {
        margin-bottom: 2rem;
    }
    @media (min-width: 1190px) {
        margin: 0 -10px;
        flex-direction: row;
        > * {
            flex-basis: calc(50% - 20px);
            margin: 0 10px 2rem 10px;
        }
    }
`;
